import React, { memo } from 'react'
import { OutlinedField } from '../Forms'

const UrlField = memo(({ classes, handleChange, value, disable }: any) => {
  return (
    <OutlinedField
      label="Url"
      className={classes.textField}
      value={value}
      onChange={handleChange('url')}
      required
      disabled={disable}
    />
  )
})

export default UrlField
